import { EmployeeType } from "winslow-core";
import "./AppEmployeeRecordTypeSelector.css";
import { GenericSelect } from "../../shared/GenericSelect";
import { Button } from "../../../ds2/components";
import { useRef, useState } from "react";

type AppEmployeeRecordTypeSelectorProps = {
    onSubmit: (employeeType: EmployeeType) => void;
}

export const AppEmployeeRecordTypeSelector = ({onSubmit} : AppEmployeeRecordTypeSelectorProps) => {

    // const [currentValue, setCurrentValue] = useState<string | undefined>(undefined);

    const containerRef = useRef(null)

    const employeeTypeOptions = [
        {displayName: "US Full Time", value: EmployeeType.US_FULL_TIME},
        {displayName: "US Part Time", value: EmployeeType.US_PART_TIME},
        {displayName: "US Contractor", value: EmployeeType.US_CONTRACTOR},
        {displayName: "US Vendor", value: EmployeeType.US_VENDOR},
        {displayName: "INT Full Time", value: EmployeeType.INT_FULL_TIME},
        {displayName: "INT Contractor", value: EmployeeType.INT_CONTRACTOR},
    ];

    // const selected = employeeTypeOptions.find(option => option.value === currentValue) || employeeTypeOptions[0];

    return (
        <div 
            className="app-employee-record-type-selector"
            ref={containerRef}
        >


            {/* <GenericSelect
                options={employeeTypeOptions}
                onChange={(value) => {
                    onSubmit(value);
                }}
                selected={selected}
            /> */}

            <div className="app-employee-record-type-selector-choice">
                <div className="app-employee-record-type-selector-content">
                    <h1>US Full Time</h1>
                    <p>A full time employee in the US that submits an I9.</p>
                </div>
                <div className="app-employee-record-type-selector-buttons">
                    <Button
                        variant="primary"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.US_FULL_TIME);
                            onSubmit(EmployeeType.US_FULL_TIME);
                        }}>
                        Add
                    </Button>
                    
                    {/* <button
                        className="button-save"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.US_FULL_TIME);
                            onSubmit(EmployeeType.US_FULL_TIME);
                        }}
                    >
                        Add Employee
                    </button> */}
                </div>
            </div>

            <div className="app-employee-record-type-selector-choice">
                <div className="app-employee-record-type-selector-content">
                    <h1>US Part Time</h1>
                    <p>A part time employee in the US that submits an I9.</p>
                </div>
                <div className="app-employee-record-type-selector-buttons">
                    <Button
                        variant="secondary"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.US_PART_TIME);
                            onSubmit(EmployeeType.US_PART_TIME);
                        }}>
                        Add
                    </Button>
                    
                    {/* <button
                        className="button-save"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.US_PART_TIME);
                            onSubmit(EmployeeType.US_PART_TIME);
                        }}
                    >
                        Add Employee
                    </button> */}
                </div>
            </div>

            <div className="app-employee-record-type-selector-choice">
                <div className="app-employee-record-type-selector-content">
                    <h1>US Consultant or Contractor</h1>
                    <p>
                        An individual that works for you on a 1099 basis.
                        Do not use this option if you are contracted with the company and work
                        with multiple people such as at an ad agency.
                    </p>
                </div>
                <div className="app-employee-record-type-selector-buttons">
                    <Button
                        variant="secondary"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.US_CONTRACTOR);
                            onSubmit(EmployeeType.US_CONTRACTOR);
                        }}>
                        Add
                    </Button>
                    
                    {/* <button
                        className="button-save"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.US_CONTRACTOR);
                            onSubmit(EmployeeType.US_CONTRACTOR);
                        }}
                    >
                        Add Employee
                    </button> */}
                </div>
            </div>

            <div className="app-employee-record-type-selector-choice">
                <div className="app-employee-record-type-selector-content">
                    <h1>US Vendor</h1>
                    <p>
                        An company that works for you on a 1099 basis. Note that some individuals may
                        choose to work through a company shell such as LLC. Use this option if your
                        contract has the company name on it and not the individual.
                    </p>
                </div>
                <div className="app-employee-record-type-selector-buttons">
                    <Button
                        variant="secondary"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.US_VENDOR);
                            onSubmit(EmployeeType.US_VENDOR);
                        }}>
                        Add
                    </Button>
                    
                    {/* <button
                        className="button-save"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.US_VENDOR);
                            onSubmit(EmployeeType.US_VENDOR);
                        }}
                    >
                        Add Employee
                    </button> */}
                </div>
            </div>

            <div className="app-employee-record-type-selector-choice">
                <div className="app-employee-record-type-selector-content">
                    <h1>International Full Time</h1>
                    <p>
                        A full time employee outside of the US that works for your company directly
                        and not through an EOR (Employer of Record).
                    </p>
                </div>
                <div className="app-employee-record-type-selector-buttons">
                    <Button
                        variant="secondary"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.INT_FULL_TIME);
                            onSubmit(EmployeeType.INT_FULL_TIME);
                        }}>
                        Add
                    </Button>
                    
                    {/* <button
                        className="button-save"
                        onClick={() => {
                            // setCurrentValue(EmployeeType.INT_FULL_TIME);
                            onSubmit(EmployeeType.INT_FULL_TIME);
                        }}
                    >
                        Add Employee
                    </button> */}
                </div>
            </div>

            <div className="app-employee-record-type-selector-choice">
                <div className="app-employee-record-type-selector-content">
                    <h1>International Contractor</h1>
                    <p>
                        An individual or company that works for you and is located outside of the US.
                    </p>
                </div>
                <div className="app-employee-record-type-selector-buttons">
                    <Button
                        variant="secondary"
                        onClick={() => {
                            // if (containerRef.current) {
                            //     const current = containerRef.current as any;
                            //     current.scrollTop = 0;
                            //     console.log("[AppEmployeeRecordNew] scrollTop: ", current.scrollTop);
                            // }
                            // setCurrentValue(EmployeeType.INT_CONTRACTOR);
                            onSubmit(EmployeeType.INT_CONTRACTOR);
                        }}>
                        Add
                    </Button>
                    
                    {/* <button
                        className="button-save"
                        onClick={() => {
                            // if (containerRef.current) {
                            //     const current = containerRef.current as any;
                            //     current.scrollTop = 0;
                            //     console.log("[AppEmployeeRecordNew] scrollTop: ", current.scrollTop);
                            // }
                            // setCurrentValue(EmployeeType.INT_CONTRACTOR);
                            onSubmit(EmployeeType.INT_CONTRACTOR);
                        }}
                    >
                        Add Employee
                    </button> */}
                </div>
            </div>

            <div className="end-spacer">
                { }
            </div>

        </div>
    )
}